import React, { useEffect, useRef, useState } from "react";

//Importar custom hooks.
import useRefCalculator from "../../../hooks/useRefCalculator.js";

//Importar componenetes extras.
import Loading from "../../common/Loading/Loading.jsx";
import SearcherChat from "../../common/Searcher/SearcherChat.jsx";
import TabFilter from "../../common/Tabs/TabFilter.jsx";
import ListChats from "./local_components/ListChats.jsx";
import ConnectionFailed from "../../common/Alerts/ConnectionFailed.jsx";
import ChatsTitleWithNumber from "../../common/ChatsTitleWithNumber.jsx";

// Inbox: Componente que renderiza la lista de Chats Disponibles.
// Leer en documentación "/docs" información sobre el componente.

const Inbox = ({ onChangeChat, socketConnected, setSocketConnected }) => {

    const loadingRef = useRef(null); // Referencia para el contenedor de Cargando... dentro del Inbox.
    const searchPositionLoading = useRefCalculator(loadingRef, -350, 190); // Buscar la posición de top y left en relación a la referencia del contenedor de los chats del Inbox.  
    const [loading, setLoading] = useState(true); //Estado para mostrar el contenido del chat del Inbox luego del delay del Caraando...
    const [peticionChatsSuccess, setPeticionChatsSuccess] = useState(true); //Estado para actualizar si la peticion para traer los chats del Inbox fue excitosa o no.
    const [chatsArray, setChatsArray] = useState([]); //Estado para actualizar la lista de chats en el inbox.
    const [chatsOriginal, setChatsOriginal] = useState([]); //Estado para actualizar la lista (filtrada del buscador) de chats en el inbox.
    const [filterValue, setFilterValue] = useState("activos"); //Estado para actualizar el filtro del TAB en el componente ListChat.
    const [searching, setSearching] = useState(false);
    const [searchChatFinish, setSearchChatFinish] = useState(""); //Estado para guardar el nombre del chat finalizado que se está buscando
    

    return (
        <div className="container-chats__inbox">

            <div className="container-inbox__inbox">

                {/*----Título del chat con el número de chats---*/}
                {/* <ChatsTitleWithNumber title="Chats" number={chatsArray.length} filterValue={filterValue}/> */}

                {/*--------Buscador de Chat------------*/}
                <SearcherChat dataList={chatsArray} setDataList={setChatsArray} setSearching={setSearching} filterValue={filterValue} 
                setSearchChatFinish={setSearchChatFinish} chatsOriginal={chatsOriginal} setChatsOriginal={setChatsOriginal}/>

                {/*------Tab para filtrar los chats------*/}
                <TabFilter setChats={setChatsArray} setFilterValue={setFilterValue} chats={chatsArray}
                filterValue={filterValue} setLoading={setLoading} number={chatsArray.length} />

                {/*------Contenido del Inbox----*/}
                <div className="container-inbox__chats" ref={loadingRef}>

                    {/*------------Renderiza puntos de Cargando...----------- */}
                    {loading && 
                    <Loading top={searchPositionLoading.top} left={searchPositionLoading.left} />
                    }

                    {/*-----Renderiza por si falla la conexción o la petición de los chats-----*/}
                    {!loading && (!socketConnected || !peticionChatsSuccess) &&
                        <ConnectionFailed setSocketConnected={setSocketConnected} />
                    }

                    {/*-------- Renderiza Chats disponibles---------*/}
                    {socketConnected && peticionChatsSuccess && 
                        <ListChats loading ={loading} setLoading= {setLoading} chatsArray={chatsArray} 
                        setChatsArray={setChatsArray} setPeticionChatsSuccess={setPeticionChatsSuccess}
                        onChangeChat={onChangeChat} filterValue={filterValue} searching={searching} 
                        searchChatFinish={searchChatFinish} chatsOriginal={chatsOriginal} setChatsOriginal={setChatsOriginal}/>
                    }

                </div>

            </div>
        </div>
    )
};

export default Inbox;